export default ({dataLayer = []} = {}) => ({
    // Namespace does make sense i this case, it much easier to use more explicit names.
    // This allows to easier mapping in Vue components.
    namespaced: false,
    actions: {
        triggerGTMEvent(context, event) {
            if (!event.event) {
                throw new Error('triggerGTMEvent requires a event field');
            }

            dataLayer.push(event);

            /* It's a hack to force GTM push several events */
            dataLayer.push({
                event: '',
                category: '',
                action: '',
            });
        },
    },
});
